import gql from "graphql-tag";

export const PRODUCT_MEDIA_FIELDS = gql`
  fragment mediaFieldsByType on Media {
    ... on MediaImage {
      image {
        id
        url
        height
        width
        altText
      }
    }
    ... on Video {
      sources {
        url
        mimeType
        format
        height
        width
      }
    }
  }
`;
